import { loveStoryData } from '../lib/data';
import styles from './LoveStory.module.scss';


const LoveStory = () => {
    return ( 
        <section >          
                <div className = {styles.container}>          

                    {loveStoryData.map(({id, photo}) => (
                        <div className = {styles.container__photo} key={id}> 
                        <img  className={styles.photo} src={photo} alt="love story фото Ставрополь"/>
                        </div>
                    ))}
                
                </div>
        </section>
    );
}

export default LoveStory;